export default __webpack_public_path__ + "eecb4756eda0a736d8983ce01b271958.svg";